import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { CommonStyles, CommonProperties, Color } from '../../styles';
import { scale } from '../../utils/scale.utils';
import RowView from '../RowView';
import BaseText from '../BaseText';

const MessageAlert = ({ trip }) => {
  return (
    <View style={[CommonStyles.mt3, CommonStyles.boxShadow]}>
      <RowView style={styles.container}>
        <Image source={{ uri: 'https://picsum.photos/80' }} style={styles.smallImage} />
        <View style={styles.cardHeading}>
          <BaseText style={CommonStyles.h4}>Robert N.</BaseText>
          <BaseText style={styles.mediumText}>
            Jul 8- What client are we meeting on Aug 12 ? Thanks
          </BaseText>
        </View>
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    ...CommonProperties.p3,
    ...CommonProperties.mx5,
    borderTopLeftRadius: scale(6),
    borderTopRightRadius: scale(6),
  },
  smallImage: {
    height: 44,
    width: 44,
    borderRadius: 22,
  },
  mediumText: {
    color: Color.text.medium,
  },
  cardHeading: {
    flex: 1,
    ...CommonProperties.pl3,
  },
});

export default MessageAlert;
